import { maybeAdd } from '../../utilities/getInfoFromMeta';
export function getInfo(varianOutput) {
    const nucleusMap = {
        H1: '1H',
        C13: '13C',
    };
    const { meta, procpar } = varianOutput;
    const procPar = {}; //
    for (const par of procpar) {
        procPar[par.name] = par.values;
    }
    const info = {};
    const { np, solvent, sfrq, reffrq, temp, rp, sw } = procPar;
    maybeAdd(info, 'numberOfPoints', np && Number(np[0]) / 2);
    maybeAdd(info, 'solvent', solvent && solvent[0]);
    maybeAdd(info, 'originFrequency', sfrq && sfrq[0]);
    maybeAdd(info, 'baseFrequency', reffrq && reffrq[0]);
    maybeAdd(info, 'temperature', temp && temp[0]);
    maybeAdd(info, 'phc0', rp && -Number(rp[0]));
    if (!('baseFrequency' in info) && 'originFrequency' in info) {
        maybeAdd(info, 'baseFrequency', info.originFrequency);
    }
    const { baseFrequency, originFrequency } = info;
    maybeAdd(info, 'frequencyOffset', (originFrequency - baseFrequency) * 1e6);
    maybeAdd(info, 'spectralWidth', sw && Number(sw[0]) / info.baseFrequency);
    for (let key in info) {
        if (info[key].length === 1)
            info[key] = info[key][0];
    }
    if (procPar.tn) {
        info.nucleus = procPar.tn.map((tn) => nucleusMap[tn]);
    }
    info.dimension = 1;
    info.isFid = !meta.status.isSpectrum;
    return { info, meta };
}
//# sourceMappingURL=getInfo.js.map